import cookie from "js-cookie";
import Store from "store/store-config";
import { readConfigFile } from "utils/appConfig";

const acceptLanguages = ["pt-BR", "en-US", "es-MX"];
const defaultLocale = acceptLanguages[0];

const getLocale = async () => {
  try {
    const state = Store.getState();
    const acceptLanguage = state.UserSession?.userData?.acceptLanguage;
    if (acceptLanguage && acceptLanguages.includes(acceptLanguage)) {
      return acceptLanguage;
    }

    const config = await readConfigFile();
    if (config.VITE_DEFAULT_LANGUAGE && acceptLanguages.includes(config.VITE_DEFAULT_LANGUAGE)) {
      return config.VITE_DEFAULT_LANGUAGE;
    }

    cookie.set("locale", defaultLocale, { expires: 365 });
    return defaultLocale;
  } catch (error) {
    console.error("Erro ao obter idioma:", error);
    return defaultLocale;
  }
};

export const getTimeZoneName = () => {
  const defaultTimeZone = "America/Sao_Paulo";
  try {
    const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!timeZoneName || timeZoneName === "UTC") {
      return defaultTimeZone;
    }
    return timeZoneName;
  } catch (error) {
    console.warn("Error getting timezone:", error instanceof TypeError ? "Intl.DateTimeFormat not supported" : error);
    return defaultTimeZone;
  }
};

export default getLocale;
